import { useEffect, useState } from "react";
import globals from "../../../globals";
import { useAuth } from "../../Context/store/context";
import { _get } from "../../../apiClient";
import { useSelector } from "react-redux";
import CurrentPackages from "./CurrentPackages";
import Package from "./Package";
import PackagesTable from "./PackagesTable";
import CheckoutPopup from "../Checkout/CheckoutPopup";
import { loadRazorpayScript, createOrder, processPayment } from "../Checkout/MakePayment";
import { _showToast } from "../../../toastHelper";

export default function MyPlan() {

    const packagesData = [
        {
            id: 2,
            title: "Basic",
            price: 1499,
            discountPrice: 999,
            isInclusiveTax: false,
            disocuntPercentage:
                function () {
                    return Math.round(((this.price - this.discountPrice) / this.price) * 100, 2)
                },
            idealFor: "Individual Photographers or Freelancers",
            invitations: "5 Invitations",
            isNew: true,
            isPopular: false,
            isCustom: false,
            benfits: [
                "2 Demo Pages",
                "Upto 200 Images",
                "Upto 75 Videos"
            ],
            features: [
                "Invitd Domain",
                "Profile Page",
                "Studios / Brandings : Upto 5",
                "Email Unlimited (from Invitd Domain)"
            ]
        },
        {
            id: 6,
            title: "Standard",
            price: 2999,
            discountPrice: 1999,
            isInclusiveTax: false,
            disocuntPercentage: function () {
                return Math.round(((this.price - this.discountPrice) / this.price) * 100, 2)
            },
            idealFor: "Photographers with limited events",
            invitations: "12 Invitations",
            isNew: false,
            isPopular: false,
            isCustom: false,
            benfits: [
                "5 Demo Pages",
                "Upto 500 Images",
                "Upto 160 Videos"
            ],
            features: [
                "Custom Sub-Domain",
                "Profile Page",
                "Studios / Brandings : Upto 12",
                "Email Unlimited (from Invitd Domain)"
            ]
        },
        {
            id: 7,
            title: "Premium",
            price: 3999,
            discountPrice: 2999,
            isInclusiveTax: false,
            disocuntPercentage: function () {
                return Math.round(((this.price - this.discountPrice) / this.price) * 100, 2)
            },
            idealFor: "Photographers with more events",
            invitations: "25 Invitations",
            isNew: false,
            isPopular: true,
            isCustom: false,
            benfits: [
                "10 Demo Pages",
                "Upto 1100 Images",
                "Upto 375 Videos"
            ],
            features: [
                "Custom Sub-Domain",
                "Profile Page",
                "Studios / Brandings : Upto 25",
                "Email Unlimited (from Invitd Domain)"
            ]
        },
        {
            title: "Enterprise",
            price: 0,
            discountPrice: 0,
            disocuntPercentage: function () {
                return Math.round(((this.price - this.discountPrice) / this.price) * 100, 2)
            },
            idealFor: "For Enterprise users",
            invitations: "More than 25 Invitations",
            isNew: false,
            isPopular: false,
            isCustom: true,
            benfits: [,
                "Customizable Demo Pages",
                "Customizable Image Count",
                "Customizable Video Count",
            ],
            features: [,
                "Your Own Domain",
                "Profile Page",
                "Studios / Brandings : Unlimited",
                "Email Unlimited (from your domain)"
            ]
        }
    ]

    const { logoutuser, showLoader, hideLoader, getToken, updateTitleAndIcon } = useAuth();
    const userDetails = useSelector((state) => state.admininfo.admininfo);
    const [data, setData] = useState(null);
    const [userPackages, setUserPackages] = useState(null);
    const [showCheckout, setShowCheckout] = useState(false);
    const [selectedPackage, setSelectedPackage] = useState(null);

    useEffect(() => {
        if (!getToken())
            logoutuser();
        updateTitleAndIcon(globals.myplan.title, globals.myplan.icon);
    }, []);

    useEffect(() => {
        if (userDetails) {
            getStatistics();
            getUserPackages();
        }
    }, [userDetails]);

    const getStatistics = async () => {
        showLoader();
        await _get(`/statistics/dashboard`)
            .then(response => {
                setData(response);
                hideLoader();
            }).catch(error => {
                console.error("Error while fetching statistics:", error);
                hideLoader();
            });
    }

    const getUserPackages = async () => {
        showLoader();
        await _get(`/app-user-packages/byuser`)
            .then(response => {
                setUserPackages(response);
                hideLoader();
            }).catch(error => {
                console.error("Error while fetching user packages:", error);
                hideLoader();
            });
    }

    const packageSelectHandler = async (pkg) => {
        setSelectedPackage(pkg);
        setShowCheckout(true);
    }

    const closeCheckoutHanlder = async () => {
        setShowCheckout(false);
        setSelectedPackage(null);
    }

    const proceedToPaymentHandler = async (pkg) => {
        setShowCheckout(false);
        showLoader();
        let response = await createOrder(userDetails.id, pkg.id);

        if (response != 'failed') {
            if (response == "Success") {
                hideLoader();
                _showToast("Thanks! You’re Registered for the Package.", "success");
            }
            else {
                await makePayment(userDetails, response);
            }
        }

        hideLoader();
    }

    const makePayment = async (userdetails, orderId) => {
        const scriptLoaded = await loadRazorpayScript(
            "https://checkout.razorpay.com/v1/checkout.js"
        );

        if (!scriptLoaded) {
            _showToast("Razorpay SDK failed to load. Are you online?", "info");
            return;
        }

        var options = {
            currency: "INR",
            order_id: orderId,
            handler: async function (response) {
                showLoader("Please do not close the browser or refresh the page. We are currently processing your payment. This may take a moment.");
                let status = await processPayment(response);
                hideLoader();
                if (status) {
                    _showToast("Thanks! You’re Registered for the Package.", "success");
                    getStatistics();
                    getUserPackages();
                }
            },
            prefill: {
                name: userdetails.firstName + " " + userdetails.lastName,
                email: userdetails.email,
                contact: userdetails.contactNo,
            }
        };

        var rzp1 = new window.Razorpay(options);
        rzp1.on("payment.failed", function (response) {
            _showToast(response.error.description, "info");
        });
        rzp1.open();
    };

    return (
        <>
            <div className="content-wrapper">
                <div className="container-xxl flex-grow-1 container-p-y">
                    <div className="row  gap-3 gap-xl-0">
                        <div className="col-12 col-xl-4">
                            <CurrentPackages data={data} />
                        </div>
                        <div className="col-12 col-xl-8">
                            <PackagesTable data={userPackages} />
                        </div>
                    </div>
                    <div className="divider my-4"></div>
                    <div className="d-flex flex-column gap-0 mp-2 rounded justify-content-center align-items-center">
                        <div className="w-100 mb-4">
                            <div className="mb-5">
                                <h3 className="text-center">Upgrage Plan</h3>
                            </div>
                            <div className="w-100 gap-4 gap-md-0 justify-content-center mb-3 row">
                                {packagesData.map((pkg, index) => {
                                    return <Package data={pkg} key={index} onPackageSelect={packageSelectHandler} />
                                })}
                            </div>
                        </div>
                    </div>

                    <div className="mt-3 mb-3 justify-content-center text-center">
                        <h3 className="mb-0">Not sure which plan to select !!</h3>
                        <small>Our experts will help you out</small>
                        <div className="mt-3">
                            <button className=" px-4 btn btn-primary">Get a callback </button>
                        </div>
                    </div>
                </div>
            </div>
            {
                showCheckout && (<CheckoutPopup pkg={selectedPackage} onClose={closeCheckoutHanlder} onPayment={proceedToPaymentHandler} />)
            }
        </>
    )
}